import { CrossIcon } from 'components/ReusableComponents/Icons/Cross'
import InfoIcon from 'components/ReusableComponents/Icons/Info'
import { useState } from 'react'

import { ReactComponent as CloseTabIcon } from './closeTab.svg'

const EmailSentNotification = ({ userEmail, handleChangeEmail }) => {
  const [isInWindow, setIsInWindow] = useState(true)

  window.onblur = function () {
    setIsInWindow(false)
  }

  document.onmouseleave = function () {
    setIsInWindow(false)
  }

  window.onmouseover = function () {
    setIsInWindow(true)
  }

  window.onfocus = function () {
    setIsInWindow(true)
  }

  return (
    <>
      <div
        className="swpm-login-phone swpm-modal-screen"
        style={{ display: isInWindow ? 'block' : 'none' }}
      >
        <div className="swpm-login-phone__container1 swpm-login-phone__container--sent">
          <div className="swpm-login-phone__info">
            <h1>Check your email</h1>
            <p>
              We've emailed a magic link to <strong>{userEmail}</strong>. Click the link
              in the email to login.
            </p>
            <p>
              <strong style={{ color: '#292121', fontWeight: 600 }}>
                <InfoIcon style={{ position: 'relative', top: 2, marginRight: 4 }} /> Keep
                this tab open in the meantime.
              </strong>
            </p>
          </div>
          <div className="swpmdl__bottom-controls">
            <button
              className="swpmdl-secondary-buttonlink"
              id="swpmdl-login-qr-button"
              onClick={handleChangeEmail}
            >
              Use a different email
            </button>
          </div>
        </div>
      </div>
      <div
        className="swpm-login-phone-dont-close swpm-modal-screen"
        //style={{ display: 'none' }}
        style={{ display: !isInWindow ? 'block' : 'none' }}
      >
        <div className="swpm-login-phone__container swpm-login-phone__container--sent">
          <div className="swpm-login-phone__info">
            {/* <CrossIcon
              fill="#ff5e5e"
              width={33}
              height={33}
            /> */}
            <CloseTabIcon height={60} fill="#ff5e5e" style={{ marginBottom: 14 }} />
            <h1 style={{ fontSize: 22, marginBottom: 8 }}>Don't close this tab!</h1>
            <p>Come back here after you click your magic link.</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default EmailSentNotification
